import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import RegieComponent from '../../../components/Mouvement/Panel/RegieComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import LignePanel from './LignePanel';

class RegiePanel extends LignePanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.REGIE;
    this.icon = { name: 'credit card outline' };
  }

  getLibelle = () => 'Régie';

  isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.identifiantRegie);

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
  ): React.ReactElement {
    return (
      <RegieComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
      />
    );
  };
}

export default RegiePanel;
